import React from 'react';
import './btn.css';

const Btn = (props) => {
    return ( <>
    <button type={props.btnType} onClick={props.btnOnClick} className={props.btnStyle}>
        <div className={props.btnIcon}></div>
        {props.btnText}
    </button>
    </> );
}
 
export default Btn;